export default __webpack_public_path__ + "static/media/service-type.f99dfbfb.svg";